<app-header></app-header>
<div id="edgefinityContentPane">
	<router-outlet></router-outlet>
</div>
<app-footer></app-footer>

<!-- User Dialog needs to exist at this level since it can be opened by the app-header (Manage Profile) -->
<app-user-dialog></app-user-dialog>

<!-- Alert Dialog exists at this level since it can be opened at any time on any page -->
<app-alert-dialog></app-alert-dialog>

<!-- Session Expiration Dialog exists at this level since it can be opened at any time on any page -->
<app-session-expiration-dialog></app-session-expiration-dialog>
